globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.SeeFullText = (function() {

    function SeeFullText($html) {
        this.$html = $html;
    }

    SeeFullText.init = function($html) {
        $html.on('click', '.see-full-text-btn', function(e){
            e.preventDefault();

            var $this    = $(this),
                $wrapper = $this.closest('.full-text-wrapper');

            $wrapper.find('.truncate-text').hide();
            $this.hide();
            $wrapper.find('.full-text').show();
        });
    }

    SeeFullText.prototype = {
        init: function() {}
    }

    return SeeFullText;

})();
